export default __webpack_public_path__ + "static/adielAvatar-eb412f499b58bb56ea018655a59d58bd.jpg";